import { apiRequest } from "./client";

export const integrationsApi = {
  getMercadoPago(projectId) {
    return apiRequest(`/projects/${projectId}/integrations/mercadopago`);
  },

  saveMercadoPago(projectId, payload) {
    return apiRequest(`/projects/${projectId}/integrations/mercadopago`, {
      method: "PUT",
      body: JSON.stringify(payload),
    });
  },

  testMercadoPago(projectId) {
    return apiRequest(`/projects/${projectId}/integrations/mercadopago/test`, {
      method: "POST",
    });
  },

  disconnectMercadoPago(projectId) {
    return apiRequest(`/projects/${projectId}/integrations/mercadopago`, {
      method: "DELETE",
    });
  },
};
